export const WAREHOUSES = {
  USA: {
    id:      "USA",
    flag:    "🇺🇸",
    label:   "USA",
    address: (name) => `LBM ${name}\n16 Germay Dr, Unit B\nWilmington, DE 19804`,
    phone:   "+12057429726",
    partner: null,
  },
  FRANCE: {
    id:      "FRANCE",
    flag:    "🇫🇷",
    label:   "France",
    address: (name) => `Reda Fouladgar - ${name}\n106 Bd Victor Hugo\n92110 Clichy, France`,
    phone:   "+33 7 59 66 65 45",
    partner: "Reda Fouladgar",
  },
  GERMANY: {
    id:      "GERMANY",
    flag:    "🇩🇪",
    label:   "Germany",
    address: (name) => `Karim Scheib - ${name}\nOverbergstraße 118\n45663 Recklinghausen`,
    phone:   "+49 174 4109240",
    partner: "Karim Scheib",
  },
  UK: {
    id:      "UK",
    flag:    "🇬🇧",
    label:   "UK",
    address: (name) => `${name}\n60 St. Augustine's Ave\nHA9 7NX, Wembley\nUnited Kingdom`,
    phone:   "+447721647666",
    partner: null,
  },
};

export const UNITS = {
  "7000": { label: "Unit 7000", desc: "Clothes, Electronics, Car Parts & General" },
  "7500": { label: "Unit 7500", desc: "Cosmetics" },
};

export const WAREHOUSE_LIST = Object.values(WAREHOUSES);
